import { render, staticRenderFns } from "./wxChat.vue?vue&type=template&id=1e94aadd&scoped=true&"
import script from "./wxChat.vue?vue&type=script&lang=js&"
export * from "./wxChat.vue?vue&type=script&lang=js&"
import style0 from "./wxChat.vue?vue&type=style&index=0&id=1e94aadd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e94aadd",
  null
  
)

export default component.exports